import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import Flex from '@components/Flex';

import OnlinePaymentMethods from './OnlinePaymentMethods';
import OfflinePaymentMethods from './OfflinePaymentMethods';
import Title from '../Title';

import messages from './messages';

const PaymentMethodsContainer = styled(Flex)`
  padding-right: ${({ theme }) => theme.constants.lateralSpace};
  margin-bottom: 40px;
`;

const Container = styled.div`
  text-align: left;
`;

function PaymentMethods({ paymentMethods }) {
  const onlineMethods = paymentMethods?.filter(x => x.online);
  const offlineMethods = paymentMethods?.filter(x => !x.online);
  return (
    <Container>
      {paymentMethods?.length && (
        <>
          <FormattedMessage {...messages.paymentMethodsTitle}>
            {label => <Title>{label}</Title>}
          </FormattedMessage>
          <PaymentMethodsContainer column>
            <OnlinePaymentMethods items={onlineMethods} />

            <OfflinePaymentMethods items={offlineMethods} />
          </PaymentMethodsContainer>
        </>
      )}
    </Container>
  );
}

PaymentMethods.propTypes = {
  paymentMethods: PropTypes.array.isRequired,
};

export default React.memo(PaymentMethods);
